import { rgba } from 'polished';
import { mq } from 'styles/breakpoints';
import { rem } from 'utils/fonts';
import colors from './colors';
import { fontSizes } from './fonts';

const appMaxWidth = 1530;
const appDesktopPadding = 35;
const appMobilePadding = 20;

export default {
  appWidth: {
    width: '100%',
    paddingLeft: `${appMobilePadding}px`,
    paddingRight: `${appMobilePadding}px`,
    maxWidth: `${appMaxWidth + 2 * appMobilePadding}px`,
    [mq.sm]: {
      paddingLeft: `${appDesktopPadding}px`,
      paddingRight: `${appDesktopPadding}px`,
      maxWidth: `${appMaxWidth + 2 * appDesktopPadding}px`,
    },
  },
  navWidth: {
    width: '100%',
    paddingLeft: `${appMobilePadding}px`,
    paddingRight: `${appMobilePadding}px`,
    maxWidth: `${appMaxWidth + 2 * appMobilePadding}px`,
    [mq.sm]: {
      paddingLeft: `${appDesktopPadding}px`,
      paddingRight: `${appDesktopPadding}px`,
      maxWidth: `${appMaxWidth + 2 * appDesktopPadding}px`,
    },
  },
  header: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '74px',
    zIndex: 999,
    bg: 'white',
    [mq.md]: {
      height: '90px',
    },
    [mq.lg]: {
      position: 'relative',
    },
  },
  mainBox: {
    paddingTop: '104px',
    [mq.md]: {
      paddingTop: '120px',
    },
    [mq.lg]: {
      paddingTop: '0px',
      marginTop: '40px',
    },
  },
  mainBoxMinimumPadding: {
    paddingTop: '74px',
    [mq.md]: {
      paddingTop: '90px',
    },
    [mq.lg]: {
      paddingTop: '0px',
      marginTop: '40px',
    },
  },
  whiteBox: {
    borderRadius: 'base',
    width: '100%',
    transform: 'translate3d(0, 0, 0)',
    willChange: 'opacity, transform',
  },
  whiteBoxContent: {
    borderRadius: 'base',
    boxShadow: 'whiteBox',
    padding: '30px 20px 26px 20px',
    [mq.md]: {
      padding: '32px 30px 30px 30px',
    },
  },
  whiteBoxContentWithoutMobilePadding: {
    borderRadius: 'base',
    boxShadow: 'whiteBox',
    padding: '0px',
    [mq.md]: {
      padding: '0px',
    },
    [mq.lg]: {
      padding: '32px 30px 30px 30px',
    },
  },
  infobox: {
    bg: 'pink.300',
    _after: {
      borderRight: `6px solid`,
      borderColor: 'pink.300',
    },
    '& path': {
      fill: 'pink.500',
    },
  },
  profileSwitcherTabs: {
    border: 'none',
    marginBottom: '35px',
    padding: '25px 25px 0 25px',
  },
  profileSwitcherYourAccountText: {
    color: 'secondary.800',
    fontWeight: 600,
  },
  logOutButton: {
    '&:hover': {
      background: 'gray.100',
    },
    '&:focus': {
      background: 'gray.100',
    },
  },
  dateSegmentWrapper: {
    fontSize: fontSizes.lgMin,
    '&:first-of-type': {
      fontSize: rem(26),
    },
  },
  settingsWrapper: {
    borderRadius: 'base',
    mt: '-10px',
    bg: 'transparent',
    [mq.md]: {
      p: '33px 40px 33px 80px',
      bg: 'white',
      mt: '35px',
    },
    [mq.lg]: {
      mt: '45px',
    },
  },
  settingsDesktopMenu: {
    w: '250px',
    pr: '30px',
    mt: '40px',
    [mq.lg]: {
      w: '390px',
    },
  },
  settingsWrapperMobile: {
    borderRadius: 'base',
    bg: 'white',
    p: '30px 20px',
    [mq.md]: {
      borderRadius: 0,
      bg: 'transparent',
      p: '17px 0 0 0',
    },
  },
  pageTitle: {
    color: 'secondary.800',
    fontWeight: 'bold',
    fontSize: fontSizes['4xl'],
    lineHeight: rem(37),
    m: '5px 0 40px 0',
    [mq.sm]: {
      fontSize: fontSizes['4xl'],
      lineHeight: rem(37),
    },
    [mq.md]: {
      display: 'none',
    },
  },
  projects: {
    wrapper: {
      padding: '20px',
    },
    projectIconsWrapper: {
      top: '-14px',
      left: '10px',
    },
    projectIcon: {
      marginRight: '-10px',
    },
    projectImage: {
      height: '200px',
      marginBottom: '35px',
    },
    projectTitle: {
      fontWeight: 600,
      fontSize: fontSizes['2xl'],
      color: 'primary.500',
    },
    projectLocation: {
      fontWeight: 500,
      fontSize: fontSizes.lg,
      color: 'secondary.500',
      marginBottom: '20px',
    },
    projectHeadline: {
      color: 'secondary.800',
      fontWeight: 600,
      fontSize: fontSizes.xl,
      paddingBottom: '25px',
    },
    projectDescriptionContainer: {
      color: 'secondary.800',
      paddingBottom: '40px',

      span: {
        fontWeight: 500,
        fontSize: fontSizes.sm,
      },
    },
    successMessageTitle: {
      fontSize: rem(30),
      fontWeight: 600,
    },
    successMessageDescription: {
      fontSize: fontSizes.lgMin,
      fontWeight: 600,
    },
    tileWrapper: {
      border: '1.5px solid',
      borderColor: 'secondary.300',
      padding: '10px',
      '&:hover': {
        borderColor: rgba(colors.pink[500], 0.5),
        button: {
          opacity: 1,
        },
      },
      [mq.lg]: {
        padding: '20px',
      },
    },
    projectInfoWrapper: {
      alignItems: 'center',
      [mq.lg]: {
        maxWidth: 'calc(100% - 60px)',
      },
    },
    projectTileTitle: {
      fontSize: fontSizes.mdMax,
      color: 'secondary.800',
      fontWeight: 500,
      [mq.md]: {
        fontSize: fontSizes.lgMax,
      },
    },
    projectTileLocation: {
      fontSize: fontSizes.md,
      color: 'secondary.500',
      [mq.md]: {
        fontSize: fontSizes.lgMin,
      },
    },
    downloadProjectButton: {
      opacity: 0,
    },
    seeProjectButton: {
      backgroundColor: 'primary.500',
      color: 'other.primaryBgText',
      opacity: 0,
    },
    SDGSubTitle: {
      fontSize: fontSizes.md,
      fontWeight: 500,
      lineHeight: '130%',
      color: 'secondary.800',
      opacity: 0.5,
      mt: '30px',
      mb: '30px',
    },
    certificateSliderWrapper: {
      marginBottom: '50px',
      [mq.md]: {
        marginBottom: '80px',
      },
    },
    certificateSectionTitle: {
      marginBottom: '22px',
      fontSize: fontSizes.lgMax,
      fontWeight: 600,
    },
    certificateCarouselOuterWrapper: {
      padding: '20px 20px 45px;',
      backgroundColor: rgba(colors.secondary[800], 0.03),
    },
    projectBlurb: {
      wrapper: {
        backgroundColor: rgba(colors.secondary[800], 0.03),
        borderRadius: '15px',
      },
      descriptionTitle: {
        fontWeight: 600,
        fontSize: fontSizes.lg,
        color: 'primary.500',
        [mq.md]: {
          fontSize: rem(26),
        },
      },
      description: {
        fontSize: fontSizes.mdMax,
        color: 'gray.800',
        fontWeight: 500,
        lineHeight: '160%',
        marginTop: '20px',
      },
      projectOwnerTitle: {
        fontSize: fontSizes.mdMax,
        color: 'secondary.500',
        width: '30%',
        whiteSpace: 'nowrap',

        [mq.md]: {
          fontSize: fontSizes.lg,
        },
      },
      projectOwnerLabel: {
        fontSize: fontSizes.mdMax,
        color: 'secondary.700',
        textAlign: 'right',
        maxWidth: '60%',
        fontWeight: 700,
        [mq.md]: {
          fontSize: fontSizes.lg,
        },
      },
    },
    projectDescription: {
      sectionTitle: {
        fontSize: fontSizes.lgMax,
        fontWeight: 600,
        marginBottom: 0,
        lineHeight: '30px',
      },
      descriptionText: {
        fontSize: fontSizes.mdMax,
        fontWeight: 500,
        lineHeight: '160%',
        marginTop: '20px',
      },
    },
    descriptionAccordion: {
      sectionTitle: {
        fontSize: fontSizes.xl,
        fontWeight: 600,
        marginBottom: 0,
        lineHeight: '18px',
        color: 'secondary.800',
      },
      descriptionText: {
        fontSize: fontSizes.mdMax,
        lineHeight: '160%',
        marginTop: '20px',
        fontWeight: 500,
      },
    },
  },
  account: {
    billing: {
      header: {
        mb: ['40px', '40px', '36px'],
        fontSize: fontSizes.lg,
        fontWeight: 600,
        lineHeight: '22px',
      },
      infoSmall: {
        fontSize: fontSizes.md,
        fontWeight: 500,
        lineHeight: '160%',
        color: 'secondary.800',
      },
      info: {
        fontSize: fontSizes.lgMin,
        fontWeight: 500,
        lineHeight: '26px',
        color: 'secondary.800',
      },
    },
    cardDetails: {
      header: {
        mb: ['40px', '40px', '45px'],
        fontSize: fontSizes.lg,
        fontWeight: 600,
      },
    },
    deleteModal: {
      header: {
        fontSize: fontSizes.xl,
        fontWeight: 600,
        lineHeight: '25px',
      },
      info: {
        fontSize: fontSizes.mdMax,
        fontWeight: 500,
      },
    },
  },
};
